export const ADMIN = 'SuperAdmin'
export const GUEST = 'Guest'
